module.exports = __webpack_public_path__ + "img/shareT.005acfbb.svg";